import { useMemo } from "react";
import {BADGES_PER_PRODUCT_BY_COUNTRY, BADGES_COUNTRIES } from "segments/desktop/grid/layouts/badges-grid/badges-const";
import { WORK_MANAGEMENT_PRODUCT_ID} from "constants/products";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import BadgesGridDesktopComponent from "./components/badges-grid-desktop/badges-grid-desktop-component";
import BadgesGridMobileComponent from "./components/badges-grid-mobile/badges-grid-mobile-component";

const BadgesGridComponent = ({ product, country, horizontalPadding }) => {
  const badges = useMemo(
    () => BADGES_PER_PRODUCT_BY_COUNTRY[product]?.[country] || 
    BADGES_PER_PRODUCT_BY_COUNTRY[product]?.[BADGES_COUNTRIES.GENERAL] || 
    BADGES_PER_PRODUCT_BY_COUNTRY[WORK_MANAGEMENT_PRODUCT_ID][BADGES_COUNTRIES.GENERAL],
    [product]
  );

  const BadgesResponsiveComponent = useMemo(
    () => withResponsiveHOC(BadgesGridDesktopComponent, BadgesGridMobileComponent),
    []
  );

  return <BadgesResponsiveComponent badges={badges} horizontalPadding={horizontalPadding} />;
};

export default BadgesGridComponent;
